import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"min-height":"92vh"} }
const _hoisted_2 = { id: "footer" }
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"blue"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$route.meta.layout), null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Version: " + _toDisplayString(_ctx.version) + "-" + _toDisplayString(_ctx.tc) + " ", 1),
      (_ctx.secret_mode)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "SECRET MODE ACTIVE "))
        : _createCommentVNode("", true),
      (_ctx.node_env)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Development"))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createTextVNode(" © Steiner s.r.o. " + _toDisplayString(new Date().getFullYear()), 1)
    ])
  ], 64))
}